export const toId = (value: string): string => {
  return String(value)
    .replace(/[^a-zA-Z0-9]+/g, '')
    .toLowerCase();
}
